var manifestCache;
function getManifest() {
    if (manifestCache)
        return manifestCache;
    return (manifestCache = process.env.BUILD_TARGET === 'client' ? window.__remixManifest : require('ttark').assets);
}
// do not pass routeId directly, webpack CSSLinksPlugin will pass the routeId
export function cssLinks(routeId) {
    return (manifestCache || getManifest()).routes[routeId].cssImports.map(function (href) { return ({ rel: 'stylesheet', href: href }); });
}
//# sourceMappingURL=index.js.map